@if (iconType() === 'custom') {
  <mat-icon [inline]="inline()" [svgIcon]="glyph()" />
} @else {
  <mat-icon [fontSet]="fontSet" [inline]="inline()">{{ glyph() }}</mat-icon>
}
